import { render } from "./Registrazione.vue?vue&type=template&id=2d75318a&scoped=true"
import script from "./Registrazione.vue?vue&type=script&lang=js"
export * from "./Registrazione.vue?vue&type=script&lang=js"

import "./Registrazione.vue?vue&type=style&index=0&id=2d75318a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d75318a"]])

export default __exports__